import React, { useState, useEffect } from 'react';
import Header from './Header';
import API_URL from '../config';

function maskCpfCnpj(value) {
  value = value.replace(/\D/g, '');
  if (value.length <= 11) {
    value = value.replace(/(\d{3})(\d)/, '$1.$2');
    value = value.replace(/(\d{3})(\d)/, '$1.$2');
    value = value.replace(/(\d{3})(\d{1,2})$/, '$1-$2');
  } else {
    value = value.replace(/(\d{2})(\d)/, '$1.$2');
    value = value.replace(/(\d{3})(\d)/, '$1.$2');
    value = value.replace(/(\d{3})(\d)/, '$1/$2');
    value = value.replace(/(\d{4})(\d{1,2})$/, '$1-$2');
  }
  return value;
}

function maskTelefone(value) {
  value = value.replace(/\D/g, '');
  if (value.length <= 10) {
    value = value.replace(/(\d{2})(\d)/, '($1)$2');
    value = value.replace(/(\d{4})(\d)/, '$1-$2');
  } else {
    value = value.replace(/(\d{2})(\d)/, '($1)$2');
    value = value.replace(/(\d{5})(\d)/, '$1-$2');
  }
  return value;
}

function RevendaPage({ usuario, revenda, onVoltar, onSair }) {
  const [form, setForm] = useState({
    id: null,
    documento: '',
    ie_rg: '',
    indicador_ie: '',
    razao: '',
    fantasia: '',
    email: '',
    telefone: '',
    path_imagem: '',
    senha_cert: '',
    vencimento_cert: '',
    csc_id: '',
    csc: '',
    cep: '',
    rua: '',
    numero: '',
    complemento: '',
    bairro: '',
    cidade: '',
    estado: '',
    ibge: '',
    interface: '',
    token: '',
    utiliza_tabelas_precos: false,
    tabelas_precos: [],
    taxa_servico: '',
    taxa_percentual: '',
    cash_percentual: '',
    autopagamento: false,
    gerenciar_impressao: false,
    ativo: true,
  });
  const [loading, setLoading] = useState(true);
  const [erro, setErro] = useState('');

  useEffect(() => {
    if (revenda && revenda.id) {
      fetchRevenda();
    }
    // eslint-disable-next-line
  }, [revenda?.id]);

  const fetchRevenda = async () => {
    setLoading(true);
    setErro('');
    try {
      const res = await fetch(`${API_URL}/pessoas/${revenda.id}`);
      const data = await res.json();
      // Buscar endereço
      let endereco = {};
      try {
        const resEnd = await fetch(`${API_URL}/pessoas_enderecos?pessoa_id=${revenda.id}`);
        const endData = await resEnd.json();
        if (Array.isArray(endData) && endData.length > 0) {
          endereco = endData[0];
        }
      } catch {}
      setForm({
        id: data.id,
        documento: data.documento ? maskCpfCnpj(data.documento) : '',
        ie_rg: data.ie_rg || '',
        indicador_ie: data.indicador_ie !== undefined && data.indicador_ie !== null ? String(data.indicador_ie) : '',
        razao: data.razao || '',
        fantasia: data.fantasia || '',
        email: data.email || '',
        telefone: data.telefone ? maskTelefone(data.telefone) : '',
        path_imagem: data.path_imagem || '',
        senha_cert: data.senha_cert || '',
        vencimento_cert: data.vencimento_cert ? new Date(data.vencimento_cert).toISOString().slice(0, 10) : '',
        csc_id: data.csc_id || '',
        csc: data.csc || '',
        cep: endereco.cep || '',
        rua: endereco.rua || '',
        numero: endereco.numero || '',
        complemento: endereco.complemento || '',
        bairro: endereco.bairro || '',
        cidade: endereco.cidade || '',
        estado: endereco.estado || '',
        ibge: endereco.ibge || '',
        interface: data.interface || '',
        token: data.token || '',
        utiliza_tabelas_precos: data.utiliza_tabelas_precos || false,
        tabelas_precos: data.tabelas_precos ? String(data.tabelas_precos).split(',').map(s => s.trim()).filter(Boolean) : [],
        taxa_servico: data.taxa_servico || '',
        taxa_percentual: data.taxa_percentual || '',
        cash_percentual: data.cash_percentual || '',
        autopagamento: data.autopagamento || false,
        gerenciar_impressao: data.gerenciar_impressao || false,
        ativo: data.ativo !== undefined ? data.ativo : true,
      });
    } catch {
      setErro('Erro ao buscar dados da revenda');
    }
    setLoading(false);
  };

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setForm(f => ({
      ...f,
      [name]: type === 'checkbox' ? checked : value
    }));
  };

  return (
    <div className="min-h-screen bg-gradient-to-br from-blue-100 to-blue-300">
      <Header usuario={usuario} empresa={revenda} onVoltar={onVoltar} onSair={onSair} />
      <div className="max-w-3xl mx-auto mt-10 bg-white rounded-lg shadow-lg p-6 relative">
        <h2 className="text-2xl font-bold text-blue-700 mb-6">Dados da Revenda</h2>
        {erro && <div className="text-red-600 mb-4">{erro}</div>}
        {loading ? (
          <div>Carregando...</div>
        ) : (
          <form className="space-y-4">
            <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">Razão Social*</label>
                <input name="razao" value={form.razao} onChange={handleChange} className="border rounded px-3 py-2 w-full" disabled />
              </div>
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">Nome Fantasia*</label>
                <input name="fantasia" value={form.fantasia} onChange={handleChange} className="border rounded px-3 py-2 w-full" disabled />
              </div>
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">Documento*</label>
                <input name="documento" value={form.documento} onChange={handleChange} className="border rounded px-3 py-2 w-full" disabled />
              </div>
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">IE/RG</label>
                <input name="ie_rg" value={form.ie_rg} onChange={handleChange} className="border rounded px-3 py-2 w-full" disabled />
              </div>
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">Email</label>
                <input name="email" value={form.email} onChange={handleChange} className="border rounded px-3 py-2 w-full" disabled />
              </div>
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">Telefone</label>
                <input name="telefone" value={form.telefone} onChange={handleChange} className="border rounded px-3 py-2 w-full" disabled />
              </div>
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">CEP</label>
                <input name="cep" value={form.cep} onChange={handleChange} className="border rounded px-3 py-2 w-full" disabled />
              </div>
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">Endereço</label>
                <input name="rua" value={form.rua} onChange={handleChange} className="border rounded px-3 py-2 w-full" disabled />
              </div>
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">Número</label>
                <input name="numero" value={form.numero} onChange={handleChange} className="border rounded px-3 py-2 w-full" disabled />
              </div>
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">Complemento</label>
                <input name="complemento" value={form.complemento} onChange={handleChange} className="border rounded px-3 py-2 w-full" disabled />
              </div>
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">Bairro</label>
                <input name="bairro" value={form.bairro} onChange={handleChange} className="border rounded px-3 py-2 w-full" disabled />
              </div>
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">Cidade</label>
                <input name="cidade" value={form.cidade} onChange={handleChange} className="border rounded px-3 py-2 w-full" disabled />
              </div>
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">Estado</label>
                <input name="estado" value={form.estado} onChange={handleChange} className="border rounded px-3 py-2 w-full" disabled />
              </div>
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">IBGE</label>
                <input name="ibge" value={form.ibge} onChange={handleChange} className="border rounded px-3 py-2 w-full" disabled />
              </div>
            </div>
          </form>
        )}
      </div>
    </div>
  );
}

export default RevendaPage; 